import { Nullable } from "@ctra/utils";
import { ChartEntity } from "../chart";
import { DataDescriptorEntity } from "../data-dictionary";

export interface FavouritesResponse {
  userId: string;
  pages: Record<
    string,
    [
      {
        descriptorId: string;
        chartType: string;
        dateRange: Nullable<Array<string>>;
        displayFilters?: Array<DisplayFilter>;
        dataFilters?: Array<DataFilter>;
      }
    ]
  >;
}

export interface DataFilter {
  type: FavouritesFilterConfig;
  values: Array<string | number>;
}
export type DisplayFilter = DataFilter & { version?: 2 };

export interface FavouriteChartEntity {
  dataDescriptorID: DataDescriptorEntity["id"];
  view: ChartEntity["view"];
  dateRange: Nullable<Array<string>>;
  displayFilters?: Array<DisplayFilter>;
  dataFilters?: Array<DataFilter>;
}

export type FavouritesPayload = Array<{
  descriptorId: string;
  chartType: string;
  dateRange: Nullable<Array<string>>;
  displayFilters?: Array<DisplayFilter>;
  dataFilters?: Array<DataFilter>;
}>;

export enum FavouritesFilterConfig {
  dimGroup = "dimGroup",
  herdGroup = "herdGroup",
  legend = "legend"
}

export type FavouritesList = Record<DataDescriptorEntity["id"], FavouriteChartEntity>;
export type Favourites = Record<string, FavouritesList>;
